import createSaveAPI from './createSaveAPI'
import saveTasksRegistry, {SaveTaskRegistry} from './lib/registry'

export default createSaveAPI(saveTasksRegistry as unknown as SaveTaskRegistry)
